var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 98,
    viewBox: "0 0 135 98",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.335 64C85.0081 64 99.335 49.6731 99.335 32C99.335 14.3269 85.0081 0 67.335 0C49.6618 0 35.335 14.3269 35.335 32C35.335 49.6731 49.6618 64 67.335 64Z",
    fill: "url(#paint0_linear_3887_9933)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3345 0C49.8846 0 35.707 13.9697 35.3516 31.3347C38.7182 46.1618 52.1801 59.0817 67.3345 59.0817C82.8896 59.0817 96.4411 45.6514 99.2935 30.3775C98.4486 13.4585 84.4635 0 67.3345 0Z",
    fill: "url(#paint1_linear_3887_9933)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7214 25.7553C95.816 11.0725 82.8705 0 67.335 0C51.7658 0 38.7994 11.1212 35.9316 25.8514C36.9635 30.9609 39.7724 38.9608 47.4049 42.802C59.1184 48.6967 88.4396 42.0364 92.88 37.4428C95.9876 34.2281 97.9686 29.3273 98.7214 25.7553Z",
    fill: "url(#paint2_linear_3887_9933)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7189 19.3216C91.8083 7.95636 80.5024 0 67.3345 0C53.7578 0 42.1647 8.45908 37.5156 20.3906C37.8758 24.2916 39.6451 31.4909 47.6343 35.7588C58.8118 41.7304 73.7405 40.6584 74.3529 40.3524C74.9652 40.046 94.0283 29.1587 94.0283 29.1587C94.0283 29.1587 97.1529 25.1263 96.7189 19.3216Z",
    fill: "url(#paint3_linear_3887_9933)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2117 29.2274C94.2117 15.2291 82.1799 3.88086 67.3383 3.88086C52.4963 3.88086 40.4648 15.2286 40.4648 29.2274C40.4648 36.2538 43.4973 42.6112 48.3939 47.2022C52.416 43.1809 67.3383 27.8746 67.3383 27.8746L86.1119 47.3558C91.1067 42.7533 94.2117 36.3336 94.2117 29.2274Z",
    fill: "url(#paint4_radial_3887_9933)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.074 26.6552C90.8043 23.3846 87.138 19.2988 87.138 19.2988L80.4009 21.672C80.4009 21.672 71.2142 25.8059 68.9857 27.8731C68.5905 28.2393 68.3405 28.5252 68.1924 28.7599L86.1117 47.3544C91.1068 42.7518 94.2115 36.3326 94.2115 29.2259C94.2115 28.3583 94.1645 27.5006 94.074 26.6552Z",
    fill: "url(#paint5_linear_3887_9933)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5576 29.5401L57.527 39.1501L65.5264 31.5202L64.7297 26.3232C64.7297 26.3232 63.8182 25.3652 63.0884 25.6161C62.3591 25.8679 47.5576 29.5401 47.5576 29.5401Z",
    fill: "url(#paint6_linear_3887_9933)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4785 8.49847L75.1613 10.3634H78.953C79.198 10.3634 79.4433 10.418 79.6537 10.5439C80.1833 10.8601 80.9037 11.5933 80.7518 12.8262C80.5418 14.5336 79.7054 15.2232 79.7054 15.2232L81.2289 16.1425C81.2289 16.1425 82.8838 14.2776 82.6474 11.8869C82.4869 10.2631 81.0048 9.28156 80.0707 8.81896C79.6443 8.60815 79.1783 8.49805 78.7029 8.49805H74.4785V8.49847Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0572 8.49847L59.3744 10.3634H55.5827C55.3378 10.3634 55.0924 10.418 54.882 10.5439C54.3524 10.8601 53.6321 11.5933 53.784 12.8262C53.9939 14.5336 54.8304 15.2232 54.8304 15.2232L53.3069 16.1425C53.3069 16.1425 51.6519 14.2776 51.8884 11.8869C52.0488 10.2631 53.5309 9.28156 54.4651 8.81896C54.8914 8.60815 55.3574 8.49805 55.8328 8.49805H60.0572V8.49847Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3936 47.2006C53.2521 51.7562 59.9457 54.5724 67.3379 54.5724C74.6452 54.5724 81.2671 51.8177 86.1116 47.3543L67.3379 27.873C67.3375 27.8726 52.4157 43.1794 48.3936 47.2006Z",
    fill: "url(#paint7_linear_3887_9933)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1376 19.2995H72.4121V13.5195H61.934V19.2999H47.5576V29.5415H61.87V53.8054C61.87 56.8135 64.3089 59.2524 67.3171 59.2524C70.3253 59.2524 72.7641 56.8135 72.7641 53.8054V29.5411H87.1376V19.2995Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1412 4.81445C63.8143 4.81445 61.1172 7.433 61.1172 10.6631C61.1172 13.8932 63.8143 16.5117 67.1412 16.5117C70.4682 16.5117 73.1653 13.8932 73.1653 10.6631C73.1653 7.433 70.4682 4.81445 67.1412 4.81445ZM67.221 13.559C65.6967 13.559 64.4608 12.3232 64.4608 10.7988C64.4608 9.27444 65.6967 8.03857 67.221 8.03857C68.7454 8.03857 69.9813 9.27444 69.9813 10.7988C69.9813 12.3232 68.7454 13.559 67.221 13.559Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.532 20.2969H61.52H61.4411H60.9307C60.9401 20.3212 61.3271 21.7359 62.3505 22.8501C63.37 23.9635 65.048 25.0867 67.5513 25.0842C68.5751 25.0846 69.4631 24.794 70.2057 24.3634C71.3204 23.7164 72.1146 22.7635 72.636 21.9749C73.1571 21.1858 73.4272 20.311 73.4332 20.2969H72.8272H72.8238C72.7803 20.4053 72.3335 21.4867 71.4578 22.4955C71.0204 23.0003 70.4771 23.4928 69.8289 23.856C69.1798 24.2192 68.4283 24.456 67.5517 24.4564C65.2413 24.4539 63.7545 23.4442 62.8126 22.4251C62.3441 21.9155 62.0176 21.4034 61.8098 21.0215C61.7061 20.8303 61.6318 20.4061 61.584 20.2969H61.532Z",
    fill: "#69E4E4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.19 20.2969H61.1845H61.1836H60.9306H59.3076C59.3183 20.3737 59.4548 22.216 60.5192 24.0664C61.0526 24.989 61.8323 25.9377 62.9563 26.6525C63.8538 27.2256 64.9698 27.6315 66.2961 27.7714V53.5447C66.2961 54.0645 66.7173 54.4861 67.2375 54.4861C67.7573 54.4861 68.1789 54.0649 68.1789 53.5447V27.7851C69.501 27.6583 70.6187 27.2388 71.5136 26.6444C72.3261 26.1075 72.959 25.4414 73.448 24.7569C74.1821 23.7288 74.6011 22.6598 74.8465 21.8417C75.0906 21.0232 75.1589 20.337 75.164 20.2969H73.2944C73.2923 20.3408 73.0806 21.7679 72.2258 23.1903C71.7974 23.9076 71.2183 24.5934 70.4394 25.0983C69.6581 25.6014 68.6735 25.9445 67.3297 25.9471H67.3284C65.8502 25.9445 64.7871 25.5831 63.9677 25.065C63.3541 24.6745 62.8753 24.1859 62.4955 23.6593C61.9262 22.871 61.5895 21.9953 61.4038 21.3219C61.3108 20.9857 61.2549 20.4928 61.2229 20.2973H61.19V20.2969Z",
    fill: "#122045"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 84.1562H6.6476V86.1112H4.39964V97.8429H2.24866V86.1112H0V84.1562Z",
    fill: "#38879F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2769 97.8429C13.1598 97.4909 13.0815 97.2762 13.0815 96.1609V94.0106C13.0815 92.7401 12.6513 92.2704 11.6739 92.2704H10.9306V97.8429H8.78027V84.1562H12.0258C14.2544 84.1562 15.2124 85.1926 15.2124 87.3041V88.3799C15.2124 89.7869 14.7628 90.6868 13.8048 91.1364V91.1752C14.8799 91.6248 15.2318 92.6417 15.2318 94.0695V96.181C15.2318 96.8453 15.2512 97.3344 15.4667 97.8429H13.2769ZM10.9299 86.1112V90.3155H11.7709C12.5724 90.3155 13.0615 89.9636 13.0615 88.8683V87.5188C13.0615 86.5414 12.7289 86.1112 11.9669 86.1112H10.9299Z",
    fill: "#38879F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.794 97.8429H22.6236L22.2523 95.3594H19.6129L19.2409 97.8429H17.2666L19.4564 84.1562H22.6042L24.794 97.8429ZM19.8859 93.5021H21.9586L20.9423 86.5809H20.9035L19.8859 93.5021Z",
    fill: "#38879F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9401 87.9296H28.9014V97.8429H26.9658V84.1562H29.6641L31.8344 92.3487H31.8732V84.1562H33.7894V97.8429H31.5795L28.9401 87.9296Z",
    fill: "#38879F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4205 84C41.5126 84 42.5877 85.2511 42.5877 87.4409V87.8711H40.5545V87.3044C40.5545 86.3269 40.1638 85.9556 39.4793 85.9556C38.7949 85.9556 38.4042 86.3269 38.4042 87.3044C38.4042 88.302 38.8344 89.0446 40.2421 90.2763C42.0411 91.8599 42.6078 92.9939 42.6078 94.5582C42.6078 96.7479 41.5132 97.999 39.4011 97.999C37.2896 97.999 36.1943 96.7479 36.1943 94.5582V93.7172H38.2275V94.6946C38.2275 95.6721 38.6577 96.024 39.3422 96.024C40.0266 96.024 40.4568 95.6721 40.4568 94.6946C40.4568 93.6971 40.0266 92.9544 38.619 91.7227C36.8199 90.1391 36.2532 89.0051 36.2532 87.4409C36.2532 85.2511 37.3284 84 39.4205 84Z",
    fill: "#38879F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4072 87.5389V89.3179C51.4072 91.5077 50.3514 92.7006 48.2004 92.7006H47.1835V97.8429H45.0332V84.1562H48.2004C50.3514 84.1562 51.4072 85.3485 51.4072 87.5389ZM47.1835 86.1112V90.745H48.2004C48.8849 90.745 49.2562 90.4318 49.2562 89.4544V87.4011C49.2562 86.4236 48.8849 86.1105 48.2004 86.1105H47.1835V86.1112Z",
    fill: "#38879F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3047 97.8429H58.1344L57.763 95.3594H55.1237L54.7524 97.8429H52.7773L54.9671 84.1562H58.115L60.3047 97.8429ZM55.3973 93.5021H57.47L56.4537 86.5809H56.415L55.3973 93.5021Z",
    fill: "#38879F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9927 97.8429C66.8756 97.4909 66.7974 97.2762 66.7974 96.1609V94.0106C66.7974 92.7401 66.3679 92.2704 65.3897 92.2704H64.6464V97.8429H62.4961V84.1562H65.7416C67.9709 84.1562 68.9282 85.1926 68.9282 87.3041V88.3799C68.9282 89.7869 68.4787 90.6868 67.5206 91.1364V91.1752C68.5964 91.6248 68.9483 92.6417 68.9483 94.0695V96.181C68.9483 96.8453 68.9677 97.3344 69.1832 97.8429H66.9927ZM64.6464 86.1112V90.3155H65.4874C66.2889 90.3155 66.778 89.9636 66.778 88.8683V87.5188C66.778 86.5414 66.4454 86.1112 65.6834 86.1112H64.6464Z",
    fill: "#38879F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7008 89.9241H76.6533V91.879H73.7008V95.8879H77.416V97.8429H71.5498V84.1562H77.416V86.1112H73.7008V89.9241Z",
    fill: "#38879F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8943 87.9296H81.8555V97.8429H79.9199V84.1562H82.6182L84.7879 92.3487H84.8267V84.1562H86.7435V97.8429H84.5336L81.8943 87.9296Z",
    fill: "#38879F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8555 84.1562H95.5038V86.1112H93.2551V97.8429H91.1048V86.1112H88.8562V84.1562H88.8555Z",
    fill: "#38879F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M108.095 92.7417V94.5601C108.095 96.7499 107.001 98.001 104.889 98.001C102.777 98.001 101.683 96.7499 101.683 94.5601V87.4428C101.683 85.2531 102.777 84.002 104.889 84.002C107.001 84.002 108.095 85.2531 108.095 87.4428V88.7722H106.062V87.3057C106.062 86.3282 105.632 85.9569 104.948 85.9569C104.263 85.9569 103.833 86.3282 103.833 87.3057V94.6966C103.833 95.674 104.263 96.026 104.948 96.026C105.632 96.026 106.062 95.674 106.062 94.6966V92.7417H108.095Z",
    fill: "#38879F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M117.56 97.8429H115.39L115.019 95.3594H112.379L112.007 97.8429H110.032L112.223 84.1562H115.371L117.56 97.8429ZM112.652 93.5021H114.725L113.708 86.5809H113.669L112.652 93.5021Z",
    fill: "#38879F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M124.249 97.8429C124.132 97.4909 124.053 97.2762 124.053 96.1609V94.0106C124.053 92.7401 123.623 92.2704 122.646 92.2704H121.903V97.8429H119.752V84.1562H122.998C125.227 84.1562 126.185 85.1926 126.185 87.3041V88.3799C126.185 89.7869 125.736 90.6868 124.778 91.1364V91.1752C125.854 91.6248 126.205 92.6417 126.205 94.0695V96.181C126.205 96.8453 126.225 97.3344 126.44 97.8429H124.249ZM121.902 86.1112V90.3155H122.743C123.544 90.3155 124.033 89.9636 124.033 88.8683V87.5188C124.033 86.5414 123.701 86.1112 122.939 86.1112H121.902Z",
    fill: "#38879F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M130.955 89.9241H133.907V91.879H130.955V95.8879H134.67V97.8429H128.804V84.1562H134.67V86.1112H130.955V89.9241Z",
    fill: "#38879F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3887_9933",
    x1: 35.8159,
    y1: 26.4422,
    x2: 98.854,
    y2: 37.5575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0628,
    stopColor: "#2F6C84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2158,
    stopColor: "#204E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3655,
    stopColor: "#163855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5091,
    stopColor: "#0F2A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6397,
    stopColor: "#0D2645"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3887_9933",
    x1: 35.7746,
    y1: 26.2081,
    x2: 99.0328,
    y2: 32.8568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0595,
    stopColor: "#489FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2111,
    stopColor: "#33758E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3578,
    stopColor: "#22537B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4371,
    stopColor: "#1C4674"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3887_9933",
    x1: 35.9315,
    y1: 22.5609,
    x2: 98.7214,
    y2: 22.5609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0595,
    stopColor: "#54B2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    stopColor: "#306D84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3887_9933",
    x1: 67.1379,
    y1: 40.6257,
    x2: 67.1379,
    y2: -0.0000556941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#479E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7126,
    stopColor: "#5ECCB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9405,
    stopColor: "#71E298"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3887_9933",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.9769 16.2228) scale(24.4407 24.4407)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#51B188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    stopColor: "#52B38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6805,
    stopColor: "#58C1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8489,
    stopColor: "#5BC6B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3887_9933",
    x1: 72.9545,
    y1: 22.6463,
    x2: 93.3852,
    y2: 38.6085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1632,
    stopColor: "#275B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8368,
    stopColor: "#56BBC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3887_9933",
    x1: 52.7556,
    y1: 35.555,
    x2: 61.5504,
    y2: 23.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#5BC6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0758,
    stopColor: "#59C2B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    stopColor: "#449695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    stopColor: "#347681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#2A6275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8368,
    stopColor: "#275B71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3887_9933",
    x1: 48.3933,
    y1: 41.2225,
    x2: 86.1114,
    y2: 41.2225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0611,
    stopColor: "#4AA1BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#1A426C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8193,
    stopColor: "#387EA8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogo);
export default __webpack_public_path__ + "static/media/menu-logo.9b6ed74cbdd433b3e21f042743b6cab1.svg";
export { ForwardRef as ReactComponent };